import { Translatable } from "@icc/shared/helpers";

/** Izolacja */
export class RemoteControl {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    img: string;
    description: string;
    shortDescription: string;
    /** Przypisane typy sterowania */
    rollerShutterDrivesIds?: number[];
    amount?: number;
    /** Kolejność */
    order: number;
    categoryId?: number;
    type: 'remote_control' | 'receiver';

    driveId?: number;
}